export default __webpack_public_path__ + "static/media/nintendo-ds.ce750668.png";